import React, { useState, useEffect } from 'react';
import api from '../services/api';
import TradeTable from '../components/TradeTable';
import StatisticsCard from '../components/StatisticsCard';
import './EmeraldDashboard.css';

function EmeraldDashboard() {
  const [trades, setTrades] = useState([]);
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEmeraldData();
  }, []);

  const fetchEmeraldData = async () => {
    try {
      setLoading(true);
      const [tradesRes, statsRes] = await Promise.all([
        api.get('/emerald/trades'),
        api.get('/emerald/statistics')
      ]);

      setTrades(tradesRes.data);
      setStatistics(statsRes.data);
      setLoading(false);
    } catch (err) {
      setError(`Failed to load emerald data: ${err.message}`);
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="emerald-dashboard">
      <div className="emerald-header">
        <div className="emerald-badge">PREMIUM</div>
        <h1 className="emerald-title">Emerald All-Access</h1>
        <p className="emerald-subtitle">
          Combined view of all guru trade alerts in one place
        </p>
      </div>

      <StatisticsCard statistics={statistics} />

      <div className="trades-section">
        <h2 className="section-title">All Trade Alerts</h2>
        <TradeTable trades={trades} showGuru={true} />
      </div>
    </div>
  );
}

export default EmeraldDashboard;
